import { useContext } from 'react';
import PDPStickyButtonsContext from './PDPStickyButtonsContext';
const usePdpStickyPriceRow = () => {
  return useContext(PDPStickyButtonsContext)?.stickyPriceRow ?? null;
};
export default usePdpStickyPriceRow;